import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

const TherapyDataChangeLogTableRow = (row) => {

  const { Timestamp, ColumnChanged, PreviousValue, NewValue, UpdatedBy, UpdatedById } = row;
  return (
    <tr>
      <td>{moment(Timestamp).format('lll')}</td>
      <td>{ColumnChanged}</td>
      <td>{PreviousValue}</td>
      <td>{NewValue}</td>
      <td><Link to={`/users/${UpdatedById}`}> {UpdatedBy}</Link></td>
    </tr>
  );

}
export default TherapyDataChangeLogTableRow;